import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mention } from '@atlaskit/adf-schema';
import { convertToInlineCss } from '@atlaskit/editor-common/lazy-node-view';
import { N30A } from '@atlaskit/theme/colors';
var isSSR = Boolean(process.env.REACT_SSR);

/**
 * Wrapper for ADF mention node spec to augment toDOM implementation
 * with fallback UI for lazy node view rendering / window virtualization
 * @nodeSpecException:toDOM patch
 * @returns
 */
export var mentionNodeSpec = function mentionNodeSpec() {
  if (isSSR) {
    return mention;
  }
  return _objectSpread(_objectSpread({}, mention), {}, {
    toDOM: function toDOM(node) {
      // packages/elements/mention/src/components/Mention/index.tsx
      var mentionAttrs = {
        'aria-busy': 'true',
        contenteditable: 'false',
        'data-access-level': '',
        'data-mention-id': node.attrs.id,
        'data-prosemirror-content-type': 'node',
        'data-prosemirror-node-inline': 'true',
        'data-prosemirror-node-name': 'mention',
        style: convertToInlineCss({
          display: 'inline',
          border: "1px solid transparent",
          background: "var(--ds-background-neutral, ".concat(N30A, ")"),
          color: "var(--ds-text-subtle, #505258)",
          borderRadius: '20px',
          cursor: 'pointer',
          padding: '0 0.3em 2px 0.23em',
          wordBreak: 'break-word'
        })
      };
      return ['span', mentionAttrs, node.attrs.text];
    }
  });
};